export function dateToArray(date: Date): Array<number> {
  // TODO: manage exceptions
  const dateArray = new Array<number>();
  if (date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    dateArray.push(y, m, d);
  }
   return dateArray;
}

export function arrayToDate(dateArray: Array<number>): Date {
  // TODO: manage exceptions
  const date = new Date();
  try {
    date.setFullYear(dateArray[0]);
    date.setMonth(dateArray[1] - 1);
    date.setDate(dateArray[2]);
    return date;
  } catch (e) {
    return date;
  }
  
}
